import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
// core components
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardAvatar from 'components/Card/CardAvatar.jsx'
import CardBody from 'components/Card/CardBody.jsx'

import appIcon from 'assets/app/listodon/app-icon.jpg'

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none'
  }
}

function UserProfile(props) {
  const { classes } = props
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={12}>
        <Card profile>
          <CardAvatar profile>
            <a href="#pablo" onClick={e => e.preventDefault()}>
              <img src={appIcon} alt="..." />
            </a>
          </CardAvatar>
          <CardBody profile>
            <h4 className={classes.cardTitle}>LisToDon</h4>
            <p className={classes.description}>
              Todoリストを永久ネストしてオフライン/オンラインに保存できるWebツール
            </p>

            <a href="https://listodoon.firebaseapp.com">LisToDon</a>
          </CardBody>
        </Card>
      </GridItem>
    </Grid>
  )
}

export default withStyles(styles)(UserProfile)
